'use strict'

import { FriendlyCaptchaSDK } from "@friendlycaptcha/sdk";

export function initInScope($scope) {
    let $form = $scope.find('.js-friendly-recaptcha');
    if ($form && $form.length) {
        console.log("FOUND CAPTCHA");

        let $submitBtn = $form.find('.js-friendly-recaptcha-submit');
        let $recaptcha = $form.find('.js-friendly-recaptcha__captcha');

        if ($submitBtn.length && !$submitBtn.hasClass('recaptcha-finished')) {
            $submitBtn.prop('disabled', true);
        }

        if (!window.__frcSdk) {
            window.__frcSdk = new FriendlyCaptchaSDK();
        }

        if ($recaptcha && $recaptcha.length) {
            const element = $recaptcha[0];
            const sitekey = element.getAttribute('data-sitekey');

            const widget = window.__frcSdk.createWidget({
                element: element,
                sitekey: sitekey,
                startMode: 'auto',
            });

            widget.addEventListener('frc:widget.complete', (event) => {
                const detail = event.detail;
                console.log('Widget completed, the response: ', detail && detail.response);
                
                if ($submitBtn.length) {
                    $submitBtn.addClass('recaptcha-finished');
                    $submitBtn.prop('disabled', false);
                }
            });

            widget.addEventListener('frc:widget.error', (event) => {
                const detail = event.detail;
                console.error('Something went wrong in solving the captcha: ', detail && detail.error);

                if ($submitBtn.length) {
                    $submitBtn.removeClass('recaptcha-finished');
                    $submitBtn.prop('disabled', true);
                }
            });

            widget.addEventListener('frc:widget.expire', () => {
                console.warn('The captcha solution is no longer valid, the user waited too long.');

                if ($submitBtn.length) {
                    $submitBtn.removeClass('recaptcha-finished');
                    $submitBtn.prop('disabled', true);
                }
            });
        }
    } else {
        console.log('CAPTCHA NOT FOUND');
    }
}